import { toAmountString } from '../../utils'

export function Amount({ value }) {
  return <span>{toAmountString(value)}</span>
}
